(function () {
  function requestFS(el) {
    if (!el) return;
    var request = el.requestFullscreen || el.webkitRequestFullscreen || el.msRequestFullscreen;
    if (!request) return;
    try {
      var result = request.call(el);
      if (result && result.catch) {
        result.catch(function () {
          /* Fullscreen request denied or unsupported here — the modal
             still works fine without it, just without hiding the
             browser chrome. */
        });
      }
    } catch (e) {
      /* no-op */
    }
  }

  function exitFS() {
    var isFullscreen = document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
    if (!isFullscreen) return;
    var exit = document.exitFullscreen || document.webkitExitFullscreen || document.msExitFullscreen;
    if (!exit) return;
    try {
      exit.call(document);
    } catch (e) {
      /* no-op */
    }
  }

  function watchModal(modal) {
    var observer = new MutationObserver(function () {
      if (modal.hasAttribute('open')) {
        // Let the photo itself paint first — entering fullscreen has
        // its own brief system animation on many browsers, and doing
        // it immediately made the whole modal feel slow to appear.
        // Deferring it a beat means the photo shows up right away,
        // with fullscreen (where supported) catching up a moment
        // after.
        setTimeout(function () {
          requestFS(modal);
        }, 120);
      } else {
        exitFS();
      }
    });
    observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
  }

  function init() {
    if (window.matchMedia('(min-width: 750px)').matches) return;
    document.querySelectorAll('.product-media-modal').forEach(watchModal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
